import { render, staticRenderFns } from "./WhatsappIcon.vue?vue&type=template&id=7cc23786"
import script from "./WhatsappIcon.vue?vue&type=script&lang=js"
export * from "./WhatsappIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports